// ChatWidgetEmbed.jsx
import React, { useState, useEffect } from 'react';

const ChatWidgetEmbed = () => {
  // Replace with the actual URL of your chat_widget.html on GCS
  const widgetUrl = 'https://storage.googleapis.com/gen-lang-client-0730110227-rag-sivaresume-bucket/chat_widget.html';
  const [isOpen, setIsOpen] = useState(false);

  // Listen for messages from the iframe
  useEffect(() => {
    const handleMessage = (event) => {
      // Ensure the message is from your iframe and has the expected type
      if (event.origin === new URL(widgetUrl).origin && event.data && event.data.type === 'closeChat') {
        console.log('Received closeChat message from iframe');
        setIsOpen(false);
      }
    };

    window.addEventListener('message', handleMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [widgetUrl]); // Re-run effect if widgetUrl changes

  return (
    <>
      {/* External Chat Open Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          title="Ask me" // Added title for hover text
          style={{
            position: 'fixed',
            bottom: '100px', // Changed from bottom to top
            right: '80px',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '2em',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
            border: 'none',
          }}
        >
          💬
        </button>
      )}

      {/* Chat Widget iFrame Wrapper */}
      <div
        style={{
          position: 'fixed',
          bottom: '0',
          right: isOpen ? '0' : '-500px', // Slide in/out effect
          width: '500px',
          height: '100vh',
          backgroundColor: '#f0f2f5',
          boxShadow: '-4px 0 15px rgba(0, 0, 0, 0.1)',
          zIndex: 999,
          transition: 'right 0.3s ease-in-out',
          display: 'flex',
          flexDirection: 'column',
          border: 'none',
          pointerEvents: isOpen ? 'auto' : 'none' // Disable interactions when closed
        }}
      >
        <iframe
          src={widgetUrl}
          title="Siva Chat Widget"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{
            border: 'none',
            /* The chat content within the iframe is now full-size */
          }}
        ></iframe>
      </div>
    </>
  );
};

export default ChatWidgetEmbed;